import React, { useEffect } from "react";
import { ThemeProvider } from "styled-components";
import { Routes, Route, useLocation, useNavigate } from "react-router";

import { useModuleConfig, ModuleType } from "../";

import { Container } from "./certificates.styled";
import { CheckAuthLayout } from '../../components';
import { certificatesRoutes } from './certificates.routes';
import { NotFoundPage } from '../../app/notFoundPage/notFoundPage.component';

const Certificates = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const config = useModuleConfig(ModuleType.Certificates);

  useEffect(() => {
    if (config.urls.includes(location.pathname)) {
      navigate(config.routes.init, { replace: true });
    }
  }, [location.pathname]);

  return (
    <ThemeProvider theme={config.theme}>
      <Container>
        <Routes>
          <Route element={<CheckAuthLayout />}>
            {certificatesRoutes.map((route) =>
              Object.values(route.pathSettings.urls).map((url, index) => {
                const Component = route.component;

                return (
                  <Route
                    key={`${url}-${index}`}
                    path={url}
                    element={<Component />}
                  />
                );
              })
            )}
          </Route>
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </Container>
    </ThemeProvider>
  );
};

export default Certificates;
